import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { api } from "../../hooks/apiClient";
const OrderDetail = () => {
  const { id } = useParams();
  const [ordertData, setOrderData] = useState([]);
  const [order, setOrder] = useState();
  const [loading, setLoading] = useState(true);
  async function getOrder() {
    try {
      const response = await api.get(`orders/finddetails/${id}`, {});
      const order = response.data;
      setOrder(order);
      setOrderData(order.line_items);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }
  useEffect(() => {
    getOrder();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-5 me-5 container">
      <h5 className="float-right">
        {" "}
        {order ? order.name : ""}{" "}
        <span className="magic-button magic-button-yellow">
          {order.isPaid ? "Paid" : "Payment Pending"}
        </span>
        &nbsp;
        <span className="magic-button magic-button-yellow">
          {order.fulfillment_status ?? "Unfullfilled"}
        </span>
      </h5>
      <div className="card mt-5 d-flex justify-content-center w-50 shadow p-1 mb-1 bg-body">
        <div className="card">
          <p>Order: {order.financial_status}</p>
          <p className="magic-button magic-button-yellow">
            Order: {order.fulfillment_status ?? "Unfullfilled"}
          </p>
          <p>Order: {order.isDelivered ? "Deliverd" : "Undeliverd"}</p>
          <p>Order: {order.isDispatched ? "Dispached" : "At WareHouse"}</p>
        </div>
      </div>
      <div className="card mt-2 d-flex justify-content-center w-50 shadow p-1 mb-1 bg-body">
        <div className="d-flex flex-column ">
          {ordertData && ordertData.length > 0 ? (
            <>
              {ordertData
                .filter(
                  (event) =>
                    event.fulfillable_quantity === 0 && event.isFulfilled,
                )
                .map((event, index) => (
                  <div key={index} className="card">
                    <div className="d-flex flex-wrap">
                      <span className="btn btn-sm">{event.quantity}</span>
                      {" - "}
                      <span className="btn btn-sm">
                        {event.fulfillable_quantity}
                      </span>
                      {" - "}
                      <span className="btn btn-sm">
                        {event.current_quantity}
                      </span>
                      &nbsp;
                      <span className="btn btn-sm">{event.name}</span>
                    </div>
                    &nbsp;
                    <img
                      src={event.productPic}
                      alt="Product Image"
                      style={{ width: 50, height: 50 }}
                    />
                  </div>
                ))}
              {ordertData
                .filter((event) => event.fulfillable_quantity > 0)
                .map((event, index) => (
                  <div key={index} className="card mb-1">
                    <div className="d-flex ">
                      <button className="magic-button magic-button-blue m-2">
                        <b>{event.quantity}</b>
                      </button>
                      &nbsp;
                      <button className="magic-button magic-button-yellow m-2">
                        <b>{event.fulfillable_quantity}</b>
                      </button>
                      &nbsp; &nbsp;
                      <img
                        className="p-1"
                        src="https://cdn.shopify.com/s/files/1/0578/1228/7660/files/VWT23-A_6.jpg?v=1727774698"
                        alt="Product Image"
                        style={{ width: 50, height: 50 }}
                      />
                      <span className="btn btn-sm">{event.name}</span>
                    </div>
                  </div>
                ))}

              {ordertData
                .filter(
                  (event) =>
                    event.fulfillable_quantity === 0 && !event.isFulfilled,
                )
                .map((event, index) => (
                  <div key={index} className="shadow p-1 mb-1 mt-5 bg-body">
                    <span className="btn btn-sm">Removed</span>
                    <div className="d-flex flex-wrap">
                      <img
                        src={event.productPic}
                        alt="Product Image"
                        style={{ width: 50, height: 50 }}
                      />
                      &nbsp;
                      <span className="btn btn-sm">{event.quantity}</span>
                      {" - "}
                      <span className="btn btn-sm">
                        {event.current_quantity}
                      </span>
                      &nbsp;
                      <span className="btn btn-sm">{event.name}</span>
                    </div>
                  </div>
                ))}
            </>
          ) : (
            <p>No order details available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderDetail;
